import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { UtilsService } from 'src/app/services/utils.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { RegisterComponent } from '../register/register.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() title: string;
  @Input() data: any;
  loginform: FormGroup;
  loaderVisible:boolean = false;
  userInconnu: string;
  showPassword: boolean = false;


  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private accountService: AccountService,
    private utilsService: UtilsService,
    private modalService: NgbModal,
  ) {
    this.loginform = this.initForm();
  }

  ngOnInit() {
   
  }

  
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onLogin() {
    const result = { success: true };
    this.activeModal.close(result);
  }


  initForm(): FormGroup {
    return this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }


connecter() {
  this.userInconnu = "";
  if (this.loginform.valid) {
      this.loaderVisible = true;
      let data = {
          ...this.loginform.value
      }
      this.authService.login(data)
          .subscribe((res) => {
              if (res['data']) {
                  const tokenObj = res['data'];
                  let infos = {
                      id: tokenObj.id,
                      matricule: tokenObj.matricule,
                      firstName: tokenObj.firstName,
                      lastName: tokenObj.lastName,
                      email: tokenObj.email,
                      telephone: tokenObj.telephone,
                      secteuractivite: tokenObj.secteuractivite,
                      profession: tokenObj.profession,
                      adresse: tokenObj.adresse,
                      genre: tokenObj.genre
                  }
                  let detail = {
                      id_token: tokenObj.access_token,
                      refresh_token: tokenObj.refresh_token,
                      infos: infos,
                      authorities: tokenObj.authorities
                  };
                  if (res['data']['access_token']) {
                      localStorage.setItem('microFinance', JSON.stringify(detail));
                     // localStorage.setItem('microFinanceBo', JSON.stringify(detail));
                      this.accountService.sendAccount(JSON.stringify(infos));
                      let user = detail;
                      let login = true;
                      this.loaderVisible = false;
                      this.utilsService.showToastSuccess("Effectuée avec succés", "Connexion");
                      const result = {
                         success: true,
                         user: user,
                         login: login
                         };
                      this.activeModal.close(result);
                  } else {
                    this.userInconnu = res['message'];
                      this.loaderVisible = false;
                  }
              } else {
                this.userInconnu = res['message'];
                  this.loaderVisible = false;
              }
              this.loaderVisible = false;
          }, (err) => {
              this.userInconnu = err['error']['message'] || err['error']['errors'][0]['message'];
              this.loaderVisible = false;
          });

  } else {
      this.checkValidity(this.loginform);
  }
}

checkValidity(g: FormGroup) {
  Object.keys(g.controls).forEach(key => {
      g.get(key).markAsDirty();
  });
  Object.keys(g.controls).forEach(key => {
      g.get(key).markAsTouched();
  });
  Object.keys(g.controls).forEach(key => {
      g.get(key).updateValueAndValidity();
  });
}


openRegisterModal() {
  this.activeModal.close();
  const modalRef: NgbModalRef = this.modalService.open(RegisterComponent);
  modalRef.componentInstance.title = 'Inscription';
  modalRef.componentInstance.data = { /* vos données ici */ };
  modalRef.result.then(
    (result) => {
    },
    (reason) => {
    }
  );
}

}
